import { InstituteCheckListDTO } from './../../models/institute/checkList/instituteCheckListDto';
import { Observable, ObservedValueOf } from 'rxjs';
import { GenericService } from './../generic.service';
import { Injectable } from '@angular/core';
import { PageResponse, Institute } from '../../models/institute/randomInstituteResponse';
import { InstituteDetailsResponse } from '../../models/institute/instituteDetailResponse';
import { TotalCountResponse } from '../../models/totalCountResponse';
import { SearchInstituteResponse } from '../../models/institute/searchInstituteResponse';
import { apiResponse } from '../../models/apiResponse';
import { InstituteDetailSeachRequest } from '../../models/institute/instituteDetailSeachRequest';
import { GetInstituteCheckListRequest } from '../../models/institute/checkList/getInstituteCheckListRequest';
import { CommonInstituteDetailsResponse } from '../../models/institute/commonInstituteDetailsResponse';
import { InstituteUnderGraduateOrMastersDetailsResponse } from '../../models/institute/instituteUnderGraduateOrMastersDetailsResponse';
import { InstitutesMajorResponse } from '../../models/institute/institutesMajorResponse';
import { InstitutesCoursesResponse } from '../../models/institute/institutesCoursesResponse';
import { InstituteUnderGraduateOrMastersDetailsRequest } from '../../models/institute/instituteUnderGraduateOrMastersDetailsRequest';
import { InstituteCommonDetailsRequest } from '../../models/institute/instituteCommonDetailsRequest';
import { InstituteCommonDetailsResponse } from '../../models/institute/instituteCommonDetailsResponse';
import { InstituteCommonDetailsV2Response } from '../../models/institute/instituteCommonDetailsV2Response';
import { InstituteUnderGraduateDetailsV2Response } from '../../models/institute/instituteUnderGraduateDetailsV2Response';
import { InstituteFilterCountResponse } from '../../models/institute/instituteFilterCountResponse';
import { InstituteFilterCountRequest } from '../../models/institute/instituteFilterCountRequest';
import { InstituteMasterDetailsV2Response } from '../../models/institute/InstituteMasterDetailsV2Response';
import { InstituteGraduateSchoolsWithInV2Response } from '../../models/institute/instituteGraduateSchoolsWithInV2Response';
import { InstituteTotalEnrollmentsV2Response } from '../../models/institute/instituteTotalEnrollmentsV2Response';
import { InstituteCoursesV2Response } from '../../models/institute/instituteCoursesV2Response';
import { InstituteCourseCountByCourseLevelResponse } from '../../models/institute/instituteCourseCountByCourseLevelResponse';
import { InstituteCoursesV2Request } from '../../models/institute/instituteCoursesV2Request';
import { InstituteTotalEnrollmentsV2Request } from '../../models/institute/instituteTotalEnrollmentsV2Request';
import { InstituteCourseNamesV2Request } from '../../models/institute/instituteCourseNamesV2Request';
import { InstituteAgentRequest, InstituteAgentResponse } from '../../models/institute/instituteAgentResponse';
import { InstituteCourse } from '../../models/institute/myInstituteRequest';
import { InstituteCourseSearchRequest, InstituteCourseSearchResponse } from '../../models/Institutedetails/filtersrequest';

@Injectable({
  providedIn: 'root'
})
export class InstituteService {

  constructor(private genericService: GenericService) {

  }

  getRandomInstitutes(): Observable<PageResponse<Institute>> {
    return this.genericService.get(`institutes/random`);
  };

  getInstitute(id: string): Observable<Institute> {
    return this.genericService.get(`institute/${id}`);
  };

  getInstituteDetail(id: string): Observable<CommonInstituteDetailsResponse> {
    return this.genericService.get(`institute/${id}`)
  }

  getInstituteUnderGraduateOrMastersDetails(instituteUnderGraduateOrMastersDetailsRequest: InstituteUnderGraduateOrMastersDetailsRequest): Observable<apiResponse<InstituteUnderGraduateOrMastersDetailsResponse>> {
    return this.genericService.post(`institutes/undergraduateormasters`, instituteUnderGraduateOrMastersDetailsRequest);
  }

  getInstitutesMajors(instituteid: string): Observable<apiResponse<InstitutesMajorResponse[]>> {
    return this.genericService.get(`institutes/institutesmajor/${instituteid}`)
  }
  getInstitutesCourses(instituteUnderGraduateOrMastersDetailsRequest: InstituteUnderGraduateOrMastersDetailsRequest): Observable<apiResponse<InstitutesCoursesResponse[]>> {
    return this.genericService.post(`institutes/institutecourses`, instituteUnderGraduateOrMastersDetailsRequest);
  }

  getTotalInstitutesInCountry(countryId: string): Observable<TotalCountResponse> {
    return this.genericService.get(`institutes/${countryId}`)
  }

  searchInstitute(searchText: string): Observable<SearchInstituteResponse[]> {
    return this.genericService.get(`institutes/search/${searchText}`)
  }

  // instituteDetailSearch(instituteDetailSeachRequest: InstituteDetailSeachRequest): Observable<apiResponse<Institute[]>> {
  //   return this.genericService.post('institutes', instituteDetailSeachRequest);
  // }
  instituteDetailSearch(instituteDetailSeachRequest: InstituteDetailSeachRequest): Observable<PageResponse<Institute>> {
    return this.genericService.post('institutes', instituteDetailSeachRequest);
  }


  getFilterCounts(request: InstituteFilterCountRequest): Observable<InstituteFilterCountResponse> {
    return this.genericService.post('institutes/filter-counts', request);
  }

  getCheckList(getInstituteCheckList: GetInstituteCheckListRequest): Observable<InstituteCheckListDTO> {
    return this.genericService.post(`institute/checklist`, getInstituteCheckList);
  }

  updateCheckList(request: InstituteCheckListDTO): Observable<InstituteCheckListDTO> {
    return this.genericService.put(`institute/checklist`, request);
  }

  getSimilarInstitutes(instituteId: string): Observable<PageResponse<Institute>> {
    return this.genericService.get(`institutes/similarinstitutes/${instituteId}`);
  }
  listInstitutesByCountryAndSearchText(instituteCommonDetailsRequest: InstituteCommonDetailsRequest): Observable<apiResponse<InstituteCommonDetailsResponse[]>> {
    return this.genericService.post(`institutes/countryandsearchtext`, instituteCommonDetailsRequest);
  }

  //#region Institute Details V2 API's
  getInstituteCommonDetails(instituteId: string): Observable<InstituteCommonDetailsV2Response> {
    return this.genericService.get(`v2/institute/commondetails/${instituteId}`);
  }
  getInstituteUnderGraduateDetails(instituteId: string): Observable<InstituteUnderGraduateDetailsV2Response> {
    return this.genericService.get(`v2/institute/undergraduate/${instituteId}`);
  }
  getInstituteMasterDetails(instituteId: string): Observable<InstituteMasterDetailsV2Response> {
    return this.genericService.get(`v2/institute/masters/${instituteId}`);
  }
  listInstituteGraduateSchoolsWithIn(instituteId: string): Observable<apiResponse<InstituteGraduateSchoolsWithInV2Response[]>> {
    return this.genericService.get(`v2/institute/graduate-schools-within/${instituteId}`);
  }
  listInstituteTotalEnrollments(req: InstituteTotalEnrollmentsV2Request): Observable<apiResponse<InstituteTotalEnrollmentsV2Response[]>> {
    return this.genericService.post(`v2/institute/total-enrollments`, req);
  }
  listInstituteCoursesEndpoint(req: InstituteCoursesV2Request): Observable<apiResponse<InstituteCoursesV2Response[]>> {
    return this.genericService.post(`v2/institutes/institute/courses`, req);
  }
  getInstituteCourseCountByCourseLevel(instituteId: string): Observable<InstituteCourseCountByCourseLevelResponse> {
    return this.genericService.get(`v2/institutes/institute/course-count/${instituteId}`)
  }
  //#endregion

  listInstituteCourseNames(req: InstituteCourseNamesV2Request): Observable<apiResponse<string[]>> {
    return this.genericService.post(`v2/institutes/course-names`, req)
  }
  addInstituteCourseNames(req: InstituteCourseNamesV2Request): Observable<InstituteCoursesV2Response> {
    return this.genericService.post(`institutes/course`, req);
  }

  getAgents(instituteId: string): Observable<InstituteAgentResponse> {
    return this.genericService.get(`institute/${instituteId}/agent`);
  }

  saveAgent(agent: InstituteAgentRequest): Observable<InstituteAgentResponse> {
    return this.genericService.post(`institute/agent`, agent);
  }

  updateAgent(agent: InstituteAgentRequest): Observable<InstituteAgentResponse> {
    return this.genericService.put(`institute/agent/${agent.id}`, agent);
  }

  getCoursesByInstituteId(instituteId: string): Observable<InstituteCourse[]> {
    return this.genericService.get(`institute/${instituteId}/courses`);
  }

  updateInstitute(institute: Institute): Observable<Institute> {
    return this.genericService.put(`myinstitute/${institute.id}`, institute);
  }

  searchCourses(request: InstituteCourseSearchRequest): Observable<InstituteCourseSearchResponse> {
    return this.genericService.post('institute/search-course', request);
  }

  getControlOfInstitution(): Observable<apiResponse<string[]>> {
    return this.genericService.get(`institute/controlofinstitute`);
  }
}

